




import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { useEffect, useState } from "react"
import styled from "styled-components"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showModal } from "../../../features/modal/modalSlice"
import PageTopTitle from "../../shared/PageTopTitle"
import TopMenus from "../../shared/TopMenus"
import ProfileAracDetails from "../../profileAraclar/ProfileAracDetails"
import ProfileAracDocs from "../../profileAraclar/ProfileAracDocs"

const ModalContainer = styled.div`
    position: fixed;
    right: 0;
    bottom: 0;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    z-index: 26;
    padding-top: 80px;
    .modal{
        width: 1400px;
        height: auto;
        max-height: 800px;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            padding: 40px;
            width: calc(100% - 80px);
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;

            .top-menu-container{
                width: 100%;
                height: auto;
            }

            .main-content{
                width: 100%;
            }
        }
    }

    @media (max-width: 1000px){
        .content{
            padding: 15px !important;
            width: 100% !important;

        }


    }


    @media (max-width: 850px){
        padding-top: 0;

        .modal{
            width: 100vw !important;
            height: 100vh !important;
            max-height: 100vh !important;
            border-radius: 0;

        }


    }

`

const menuList = [
    {
        id: 1,
        text: "Araç Detayları"
    },
    {
        id: 2,
        text: "Araç Belgeleri"
    },
]

const CompanyAracItemModal = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const {companyAracItem} = useSelector(state => state.companyProfile)

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const [activeMenuId, setActiveMenuId] = useState(1)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Araç Detayları"}/>
        <div className="content">
            <div className="top-menu-container">
                <TopMenus activeMenuId={activeMenuId} setActiveMenuId={setActiveMenuId} menuList={menuList}/>
            </div>
            <div className="main-content">
                {
                    activeMenuId === 1 &&
                    <ProfileAracDetails aracItem={companyAracItem}/>
                }
                {
                    activeMenuId === 2 &&
                    <ProfileAracDocs aracItem={companyAracItem}/>
                }
            </div>
        </div>
    </div>
</ModalContainer>
  )
}

export default CompanyAracItemModal